<div class="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-indigo-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="mx-auto h-12 w-auto" src="https://storage.googleapis.com/monecocmsfiles/logo_moneco_full_01ed69a2e8.svg" alt="Moneco">
    <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
      {{ mode === 'forgot_password' ? 'Reset your password' : 'Sign in to your account' }}
    </h2>
    <p *ngIf="mode === 'forgot_password' && !forgotPasswordSent" class="mt-2 text-center text-sm text-gray-600">
      Enter your work email and we'll send you instructions to reset your password.
    </p>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-6 shadow rounded-lg sm:px-10">

      <!-- Session Expired Alert -->
      <div *ngIf="sessionExpiredMessage" class="mb-6 bg-amber-50 border-l-4 border-amber-400 p-4 rounded-md animate-fade-in-up">
        <div class="flex">
          <div class="shrink-0">
            <svg class="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-amber-800 font-medium">{{ sessionExpiredMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Error Alert -->
      <div *ngIf="errorMessage" class="mb-6 bg-red-50 border-l-4 border-red-400 p-4 rounded-md animate-fade-in-up">
        <div class="flex">
          <div class="shrink-0">
            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-red-700 font-medium">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Mode 1: Magic Link (Primary) -->
      <div *ngIf="mode === 'magic_link'">
        <form #magicLinkForm="ngForm" (ngSubmit)="submitMagicLink()" class="space-y-6" *ngIf="!submitted">
          <div>
            <label for="magic-email" class="block text-sm font-medium text-gray-700">Email address</label>
            <div class="mt-1">
              <input [(ngModel)]="email"
                     name="email"
                     #magicEmailInput="ngModel"
                     required
                     pattern="^[a-zA-Z0-9._%+-]+@moneco\.app$"
                     id="magic-email"
                     type="email"
                     placeholder="you@moneco.app"
                     class="block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 text-base placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            </div>
            <p *ngIf="magicEmailInput.invalid && (magicEmailInput.dirty || magicEmailInput.touched)" class="mt-2 text-sm text-red-600">
              <span *ngIf="magicEmailInput.errors?.['required']">Email is required.</span>
              <span *ngIf="magicEmailInput.errors?.['pattern']">Only <strong>moneco.app</strong> email addresses are allowed.</span>
            </p>
          </div>

          <div>
            <button type="submit"
                    [disabled]="magicLinkForm.invalid || loading"
                    class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
              <svg *ngIf="loading" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
              <span>{{ loading ? 'Sending link...' : 'Send magic link' }}</span>
            </button>
          </div>

          <div class="mt-6">
            <div class="relative">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-200"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-2 bg-white text-gray-500">Or</span>
              </div>
            </div>

            <div class="mt-6 text-center">
              <button type="button"
                      (click)="setMode('password')"
                      class="text-sm font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
                Sign in with password instead
              </button>
            </div>
          </div>
        </form>

        <!-- Magic Link Confirmation -->
        <div class="text-center animate-fade-in-up" *ngIf="submitted && email">
          <div class="flex items-center justify-center mt-4">
            <div class="animate-bounce-slow bg-indigo-100 rounded-full p-4 shadow-inner">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-18 0a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
              </svg>
            </div>
          </div>
          <h3 class="mt-6 text-lg font-semibold text-gray-900">Check your email</h3>
          <p class="mt-2 text-sm text-gray-600 max-w-sm mx-auto">
            We've sent a sign-in link to <strong class="text-indigo-700">{{ email }}</strong>. Click the link in the email to sign in.
          </p>
          <div class="mt-6 space-y-2">
            <button type="button"
                    (click)="submitted = false"
                    class="text-sm font-medium text-indigo-600 hover:text-indigo-500 block w-full text-center">
              Use a different email address
            </button>
            <button type="button"
                    (click)="setMode('password')"
                    class="text-sm text-gray-500 hover:text-gray-700 block w-full text-center">
              Sign in with password instead
            </button>
          </div>
        </div>
      </div>

      <!-- Mode 2: Password Login (Secondary) -->
      <div *ngIf="mode === 'password'">
        <form #passwordForm="ngForm" (ngSubmit)="submitPassword()" class="space-y-6">
          <div>
            <label for="pwd-email" class="block text-sm font-medium text-gray-700">Email address</label>
            <div class="mt-1">
              <input [(ngModel)]="email"
                     name="email"
                     #pwdEmailInput="ngModel"
                     required
                     pattern="^[a-zA-Z0-9._%+-]+@moneco\.app$"
                     id="pwd-email"
                     type="email"
                     placeholder="you@moneco.app"
                     class="block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 text-base placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            </div>
            <p *ngIf="pwdEmailInput.invalid && (pwdEmailInput.dirty || pwdEmailInput.touched)" class="mt-2 text-sm text-red-600">
              <span *ngIf="pwdEmailInput.errors?.['required']">Email is required.</span>
              <span *ngIf="pwdEmailInput.errors?.['pattern']">Only <strong>moneco.app</strong> email addresses are allowed.</span>
            </p>
          </div>

          <div>
            <div class="flex items-center justify-between">
              <label for="pwd-password" class="block text-sm font-medium text-gray-700">Password</label>
              <button type="button"
                      (click)="setMode('forgot_password')"
                      class="text-sm font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
                Forgot password?
              </button>
            </div>
            <div class="mt-1 relative rounded-md shadow-sm">
              <input [(ngModel)]="password"
                     name="password"
                     #pwdInput="ngModel"
                     required
                     [type]="showPassword ? 'text' : 'password'"
                     id="pwd-password"
                     placeholder="••••••••"
                     class="block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 pr-10 text-base placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <button type="button"
                      (click)="toggleShowPassword()"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
                <svg *ngIf="!showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                <svg *ngIf="showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" />
                </svg>
              </button>
            </div>
            <p *ngIf="pwdInput.invalid && (pwdInput.dirty || pwdInput.touched)" class="mt-2 text-sm text-red-600">
              <span *ngIf="pwdInput.errors?.['required']">Password is required.</span>
            </p>
          </div>

          <div>
            <button type="submit"
                    [disabled]="passwordForm.invalid || loading"
                    class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
              <svg *ngIf="loading" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
              <span>{{ loading ? 'Signing in...' : 'Sign in' }}</span>
            </button>
          </div>

          <div class="mt-6">
            <div class="relative">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-200"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-2 bg-white text-gray-500">Or</span>
              </div>
            </div>

            <div class="mt-6 text-center">
              <button type="button"
                      (click)="setMode('magic_link')"
                      class="text-sm font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
                Sign in with email link instead
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- Mode 3: Forgot Password -->
      <div *ngIf="mode === 'forgot_password'">
        <form #forgotForm="ngForm" (ngSubmit)="submitForgotPassword()" class="space-y-6" *ngIf="!forgotPasswordSent">
          <div>
            <label for="forgot-email" class="block text-sm font-medium text-gray-700">Email address</label>
            <div class="mt-1">
              <input [(ngModel)]="email"
                     name="email"
                     #forgotEmailInput="ngModel"
                     required
                     pattern="^[a-zA-Z0-9._%+-]+@moneco\.app$"
                     id="forgot-email"
                     type="email"
                     placeholder="you@moneco.app"
                     class="block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 text-base placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            </div>
            <p *ngIf="forgotEmailInput.invalid && (forgotEmailInput.dirty || forgotEmailInput.touched)" class="mt-2 text-sm text-red-600">
              <span *ngIf="forgotEmailInput.errors?.['required']">Email is required.</span>
              <span *ngIf="forgotEmailInput.errors?.['pattern']">Only <strong>moneco.app</strong> email addresses are allowed.</span>
            </p>
          </div>

          <div>
            <button type="submit"
                    [disabled]="forgotForm.invalid || loading"
                    class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
              <svg *ngIf="loading" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
              <span>{{ loading ? 'Sending reset link...' : 'Send reset link' }}</span>
            </button>
          </div>

          <div class="text-center">
            <button type="button"
                    (click)="setMode('password')"
                    class="text-sm font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
              Back to sign in
            </button>
          </div>
        </form>

        <!-- Forgot Password Sent Confirmation -->
        <div class="text-center animate-fade-in-up" *ngIf="forgotPasswordSent">
          <div class="flex items-center justify-center mt-4">
            <div class="animate-bounce-slow bg-indigo-100 rounded-full p-4 shadow-inner">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-18 0a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
              </svg>
            </div>
          </div>
          <h3 class="mt-6 text-lg font-semibold text-gray-900">Reset link sent</h3>
          <p class="mt-2 text-sm text-gray-600 max-w-sm mx-auto">
            We've sent a password reset link to <strong class="text-indigo-700">{{ email }}</strong>. Click the link in the email to set a new password.
          </p>
          <div class="mt-6">
            <button type="button"
                    (click)="setMode('password')"
                    class="text-sm font-medium text-indigo-600 hover:text-indigo-500 block w-full text-center">
              Return to sign in
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

